// 引入axios
import axios from 'axios'
// 引入vuex
import store from '../store/index'
// 引入element-ui
import {
  Message,
  MessageBox,
  Loading
} from 'element-ui'
import Vue from 'vue'
let V = new Vue();
// 引入logout方法
import {
  logOut
} from './login.js'
import {
  grant_type,
  client_id,
  client_secret
} from '../common/const.js'
import {
  setNewGuid
} from '../common/utils.js'

// axios设置
axios.defaults.timeout = 600000
axios.defaults.headers.post['Content-Type'] = 'application/x-www-form-urlencoded;charset=utf-8'
axios.defaults.withCredentials = true; // 前端跨域传递cookie设置

// 获取有效的guid
function getGuid() {
  let id
  let soleGuid = localStorage.getItem('soleGuid') ? JSON.parse(localStorage.getItem('soleGuid')) : null
  if (soleGuid && soleGuid.time) {
    //当当前时间>存储的guid过期时间  代表过期了重新获取新guid存储
    if (new Date().getTime() > soleGuid.time) {
      localStorage.setItem("soleGuid", setNewGuid()); //存储GUID
      let newGuid = JSON.parse(setNewGuid())
      id = newGuid.guid
    } else {
      id = soleGuid.guid
    }
  } else {
    localStorage.setItem("soleGuid", setNewGuid()); //存储GUID
    let newGuid = JSON.parse(setNewGuid())
    id = newGuid.guid
  }
  return id
}

// 请求实例1：不需要token调用此实例
export function request1(config) {
  //let xClientId = getGuid();//获取 缓存guid
  const instance = axios.create({
    // baseURL: 'http://8.136.215.63:7000'
  })
  instance.interceptors.request.use(config => {
    // 添加自定义字段到请求头
    //config.headers['x-client-id'] = xClientId
    return config;
  })
  instance.interceptors.response.use(res => {
    const status = res.status;
    if (status === 200 || status === 301 || status === 302 || status === 303) {
      // if (res.data.code == 403) {
      //   V.$alert(res.data.message ?res.data.message :'您没有权限，如需开通请联系直属上级(在角色身份设置中授权当前操作)');
      //   return false;
      // }
      return res;
    }
  }, err => {
    if (err && err.response && err.response.status) {
      const status = err.response.status;
      // 403
      if (status === 401) {
        // V.$message({
        //   message: '登录超时',
        //   type: 'warning',
        //   duration: 2000,
        // });
        V.$alert('接口响应401，' +  (res.data.message || res.data.msg) + res.config.url);
        return false;
      }else if(status === 400 && err.response.data.error && err.response.data.error.indexOf('invalid_grant')>-1) {
        V.$alert('登录超时400，'+  (res.data.message || res.data.msg) + res.config.url);
        return "登录超时";
      }else if(status == 500){
        V.$alert('状态异常500，'+  '请截图联系技术人员处理! ' + err.response.config.url);
        return 
      }
    }
    // V.$message.error(err.response.data.error);
    V.$confirm(err?.response?.data?.error, '提示', {
      confirmButtonText: '确定',
      cancelButtonText: '取消',
      confirmButtonClass: 'confirmButton',
      cancelButtonClass: 'cancelButton',
      type: 'warning',
    })
    return err;
  })

  return instance(config)
}


// 请求实例2：需要token调用此实例
/** 
 * @projectName    
 * @brief         刷新token
 * @author        ganjun
 * @date          2020/06/19
 */
var isRefreshing = false; //是否正在刷新的标志
var requests = []; //多个请求时，若token正在刷新，则将请求暂时存放到数组requests中，逐个清空
var retryCount = 2;//重试次数
export function request2(config, isError = false) {
  var count = 0;
  let xClientId = getGuid();//获取 缓存guid
  axios.defaults.withCredentials = true; // 前端跨域传递cookie设置

  const instance = axios.create({})
  // 2. 请求拦截器
  instance.interceptors.request.use(config => {
    // 添加自定义字段到请求头
    config.headers['x-client-id'] = xClientId
    var authTk = loadUserToken();
    // 日期选择转化
    const moment = require('moment')
    for (const k in config.data) {
      if (config.data[k] && config.data[k] instanceof Date) {
        config.data[k] = moment(config.data[k]).add(8, 'hours').local().toISOString()
      }
    }
    if (authTk) {
      config.headers.Authorization = 'Bearer' + ' ' + authTk;
      var currentUrl = config.url.toLowerCase();
      /*判断token是否将要过期,当前请求不是刷新请求 */
      if (isAccessTokenExpired() && currentUrl.indexOf('refreshToken'.toLowerCase()) == -1) {
        if (!isRefreshing) {
          isRefreshing = true;
          getRefreshToken().then(function (res) {     
            let result = res && res.data ? res.data?.result : '';
            if (result && res.data.code ==1) {
              let expiresTime = result.expires_in + new Date() / 1000
              const tokenObj = {
                AccessToken: result.access_token,
                AccessExpiresIn: expiresTime,
                RefreshToken: result.refresh_token
              }
              sessionStorage.setItem('token', JSON.stringify(tokenObj))
              store.commit('updateToken', tokenObj)
              config.headers.Authorization = 'Bearer' + ' ' + result.access_token;
              onRrefreshed(result.access_token);
              refreshSubscribers = [];
            } else {
              logOut();
              onRrefreshed(null);
              return
              if (res.status == 401) {
                // V.$message({
                //   message: '登录超时请重新登录！',
                //   type: 'warning'
                // });
                V.$alert('状态异常401，'+ (res.data.message || res.data.msg) + res.config.url);
                // logOut();//跳转登录
              }else if (res.status == 402) {
                // V.$message({
                //   message: '请登录后再访问!',
                //   type: 'warning'
                // });
                V.$alert('状态异常402，'+ (res.data.message || res.data.msg) + res.config.url);
                // logOut();
              } else if (res.status == 403) {
                V.$message({
                  message: res.data.message || res.data.msg,
                  type: 'warning'
                });
              } 
              else if (res.status == 429) {
                // V.$message({
                //   message: '请求过于频繁请稍后再试!',
                //   type: 'warning'
                // });
                V.$alert('状态异常429，'+ (res.data.message || res.data.msg) + res.config.url);
                // logOut();
              } else if (res.status == 416) {
                // V.$message({
                //   message: '非法请求:系统已自动记录!',
                //   type: 'warning'
                // });
                V.$alert('状态异常416，'+ (res.data.message || res.data.msg) + res.config.url);
                // logOut();
              }else{
                // if(res == "登录超时"){
                //   return false
                // }
                // V.$message({
                //   message: '登录超时请重新登录！',
                //   type: 'warning'
                // });
                V.$alert('登录状态异常，'+ (res.data.message || res.data.msg) + res?.config?.url);
                logOut();
              }
              // setTimeout(() => {
              //   logOut();
              // }, 2000)
            }
          }).catch(function (err) {
            console.log(err,'失败')
            V.$alert('接口响应失败，'+ (res.data.message || res.data.msg) + res.config.url);
            logOut();
            return err;
          }).finally(() => {
            isRefreshing = false;
          })
          /*把请求(token)=>{....}都push到一个数组中*/
          var retry = new Promise(function (resolve, reject) {
            /*(token) => {...}这个函数就是回调函数*/
            subscribeTokenRefresh(function (token) {
              config.headers.Authorization = 'Bearer ' + token;
              /*将请求挂起*/
              isRefreshing = false
              resolve(config)
            })
          });
          return retry
        }
        var retry = new Promise(function (resolve, reject) {
          /*(token) => {...}这个函数就是回调函数*/
          subscribeTokenRefresh(function (token) {
            config.headers.Authorization = 'Bearer ' + token;
            /*将请求挂起*/
            isRefreshing = false
            resolve(config)
          })
        });
        return retry
        // return config;
      } else {
        return config;
      }
    } else {
      return config;
    }
  }, err => {
    return err
  })
  // 3. 响应拦截器
  instance.interceptors.response.use(res => {
    if (res.status === 200 || res.status === 301 || res.status === 302 || res.status === 303 || res.status === 403) {
      if (res.data.code == 403) {
        let resTip = res.data.message ? res.data.message :('接口'+ res.config.url +'您没有权限，如需开通请联系直属上级(在角色身份设置中授权当前操作)');
        V.$alert(resTip);
        return res.data;
      }
        return res.data;
    }
  }, err => {
    if (err && err.response && err.response.status) {
      let status = err.response.status;
      if (status === 401 || status == 403) {
        var errConfig = err.config; //失败的请求头
        var token = JSON.parse(sessionStorage.getItem('token')) || store.state.token;
        let refreshToken = token.RefreshToken;
        // 判断有无token
        if (refreshToken) {
          if (!isRefreshing) {
            isRefreshing = true;
            // count++;
            // if(count>=retryCount){
            //   return err;
            // }
            // 有token重新调用接口获取新的用户token
            getRefreshToken().then(function (res) {
              console.log(res,'res5')
              let result = res && res.data.result ? res.data.result : '';
              console.log(result,'result5')
              if (result && res.data.code ==1) {
                // 存到本地
                let expiresTime = result.expires_in + new Date() / 1000
                let tokenObj={
                  AccessToken: result.access_token,
                  AccessExpiresIn: expiresTime,
                  RefreshToken: result.refresh_token
                }
                sessionStorage.setItem('token', JSON.stringify(tokenObj))
                store.commit('updateToken', {
                  AccessToken: result.access_token,
                  AccessExpiresIn: expiresTime,
                  RefreshToken: result.refresh_token
                })
                // token超过24小时清除
                isDayToken()
                errConfig.headers.Authorization = 'Bearer ' + result.access_token; //覆盖旧accessToken
                return instance(errConfig);
              } else {
                // 非200(包含401等状态码)
                // V.$message({
                //   message: '登录超时请重新登录！',
                //   type: 'warning'
                // });
                logOut(); //跳转登录页
              }
            }).catch(function (err) {
              console.log(err,'失败2')
              V.$alert('接口响应失败了，'+ (res.data.message || res.data.msg));
              logOut(); //跳转登录页
              return err;
            }).finally(function () {
              isRefreshing = false;
            })
          }else{
               logOut();
          }
        } else {
          // 没有token
          // V.$message({
          //   message: '登录超时!',
          //   type: 'warning'
          // });
          V.$alert('登录异常，'+ err.response.data.message + err.response.config.url);
          // logOut(); //跳转登录页
        }
      }else if (status == 500) {
        V.$alert('状态异常500，'+ '请截图联系技术人员处理! ' + err.response.config.url );
      } else if (status == 429) {
        V.$alert('状态异常429，'+ err.response.data.message + err.response.config.url );
      } 
      else {
        console.log('页面出错')
      }
    }
    if(!err?.response){
      V.$alert('接口响应失败，'+ err + res?.config?.url );
      // logOut()
    }
    const _status = err.response.status;
    
    if (!isError) {
      if (_status != 403) return err;
    } else {
      return err;
    }
  })
  // 4. 返回实例
  return instance(config)
}

// 获取AccessToken
function loadUserToken() {
  let token = JSON.parse(sessionStorage.getItem('token')) || store.state.token;
  let accessToken = token.AccessToken;
  return accessToken;
}

// 判断AccessToken是否过期
function isAccessTokenExpired() {
  let token = JSON.parse(sessionStorage.getItem('token')) || store.state.token;
  let accessToken = token.AccessToken;
  let expires_in = token.AccessExpiresIn;
  if (!accessToken || !expires_in) return false;
  let currentTime = Date.parse(new Date()) / 1000;
  let expiresTime = expires_in - currentTime;
  // 60秒后即将过期,true则需要刷新
  return expiresTime <= 60
}

// 请求新AccessToken
function getRefreshToken() {
  let token = JSON.parse(sessionStorage.getItem('token')) || store.state.token;
  const refreshToken = token.RefreshToken;
  let params = new URLSearchParams();
  params.append('grant_type', grant_type);
  params.append('client_id', 'hbzsb-admin');
  params.append('client_secret', 'zsb.web.secret');
  params.append('refresh_token', refreshToken);
  return request1({
    url: '/api8/connect/token',
    method: 'post',
    data: params
  })
}

// 存储token  24小时
function isDayToken() {
  let token = JSON.parse(sessionStorage.getItem('token')) || store.state.token;
  let accessToken = token.AccessToken;
  let expires_in = token.AccessExpiresIn;
  if (!accessToken || !expires_in) return false;
  let currentTime = Date.parse(new Date()) / 1000;
  let expiresTime = expires_in;
  // 24小时后删除Token
  if (currentTime - expiresTime > 86400) {
    sessionStorage.removeItem('token')
  }
}

// 存储请求的数组
var refreshSubscribers = [];

function subscribeTokenRefresh(cb) {
  refreshSubscribers.push(cb);
}

// 数组中的请求得到新的token之后自执行，用新的token去请求数据
function onRrefreshed(token) {
  refreshSubscribers.map(function (cb) {
    return cb(token);
  })
}
// 学员中心刷新token
export function studentCenterToken() {
  if(!isAccessTokenExpired()||isRefreshing) return Promise.resolve();
    isRefreshing = true;
    return getRefreshToken().then((res)=>{
    let result = res && res.data ? res.data?.result : '';
      if(res?.data?.code == 1 && result?.access_token) {
        let expiresTime = result.expires_in + new Date() / 1000
        const tokenObj = {
          AccessToken: result.access_token,
          AccessExpiresIn: expiresTime,
          RefreshToken: result.refresh_token
        }
        sessionStorage.setItem('token', JSON.stringify(tokenObj))
        store.commit('updateToken', tokenObj)
      } else {
        V.$alert('状态异常，'+ (res.data.message || res.data.msg));
        logOut();
      }
    }).catch(function (err) {
      V.$alert('接口响应失败，'+ err);
      logOut();
      return err;
    }).finally(() => {
      isRefreshing = false;
    })
}
